import React from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Card,
  CardTitle,
  CardBody,
  CardImg,
  CardText,
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup,
  ButtonGroup
} from "reactstrap";
import { Textbox, Checkbox } from "react-inputs-validation";
import "../../../../styles/estilos.css";
import Page from "components/Page";
import ValoresCotizacion from "../../components/ValoresCotizacionRenovacion";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FetchDataProductosCarrito, FetchRecalcularCarrito, FetchTotalesCabeceraCotizadores } from "../../../../redux/actions/ACarritoProductos";
import ListadoProductos from "../../../../components/Cotizacion/ListaProductosCotizacion/ListadoProductos";
import { FetchDescargarCotizacion, GuardarLeadFetch, recuperarDatosFacturacionFetch, listarColoresFetch, listarTerritoriosFetch, listarAccesoriosFetch, listarECivilesFetch, listarGenerosFetch, FetchDescargarCotizacionAuto, FetchDescargarCotizacionRenovacion, FetchDescargarCotizacionAutoRenovacion } from "../../../../redux/actions/aCotizacion";
import { dataUsuario, formatearNumero, setDataLeeds } from "../../../../redux/actions/aLogin";
import { ambienteAplicacion, urlGetRecompraConfirmacion, urlGuardarCodigoCuotas } from "../../../../constants/urls";
import Diferidos from "../../../../components/Generales/Diferidos";
import { FetchDataBancosCuotas } from "../../../../redux/actions/APolizas";
import { apiGet } from "../../../../api";
import ListadoProductosComparador from "../../components/ListadoProductosComparadorRenovacion";
import ConfirmDialog from "../../../../components/Compras/ConfirmDialog";
import ErrorPage from "../../../../components/ErrorPage";
import { obtenerCarritoPorIdCarrito, transformarRenovacion, validarBotonContinuar } from "../../redux/aRenovaciones";
import { urlListarRenovaciones, urlModificarProducto } from "../../api/urls";
import { httpClient } from "../../../../api/httpClient";

class Cotizacion3ResumenRenovacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingSiniestralidad: false,
      renovacionActual: null,
      filtros: null,
      filtrosPymes: null,
      tieneErrorPrimaMinima: false,
      mensajeErrorPrimaMinima: '',
      primaMinima: 0.0,
      placa: "",
      validate: false,
      hasPlacaError: true,
      chasis: this.props.datosCotizacion.datosPlaca === undefined ? "" : this.props.datosCotizacion.datosPlaca.chasis,
      codigoProductoEspecial: null,
      esNoPortal: false,
      bloquearFullCobertura: false,
      bloquearFullCoberturaCarrito: false,
      mensajeBloqueo: 'Existe un vehículo con más de 15 años de antigüedad. No es posible continuar con el plan Full Cobertura, por favor, modifícalo.',
      cargandoinicial: true,
      maximoMeses: 1,
      cuotasSeleccionadas: 1,
      bancoSeleccionado: null,
      email: '',
      errorSiniestralidad: false,
      mensajeErrorSiniestralidad: '',
      renovacionActual: null,
      recalcular: false,
      recalculado: false,
      isConfirmOpen: false,
      confirmAction: null,
      message: '',

    };
    this.onDescargar = this.onDescargar.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.onEnviar = this.onEnviar.bind(this);

  }

  async obtenerRenovacion() {

    //return {transaccion: true}
    try {

      const queryParams = new URLSearchParams(this.props.location.search);
      const idCarrito = queryParams.get('id');




      const url = `${urlListarRenovaciones}${this.props.datosUsuarios.brokerCodigo}&cliCodigoCore=${this.props.datosUsuarios.cliCodigoCore}&ambiente=${ambienteAplicacion}&ramo=VEH%C3%8DCULOS`;
      const json = await httpClient.post(url, {
        "rangoFecha": null,
        "filtrosAtributos": {
          "reIdCarrito": idCarrito,
        }
      });

      return json;
    } catch (error) {
      console.error('Error en validarSiniestralidad:', error);
      alert(error)
      return {
        transaccion: false,
        mensaje: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
      };
    }
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasContraseniaActualError,
      hasContraseniaNuevaError,
      hasConfirmacionError
    } = this.state;

    if (
      !hasContraseniaActualError ||
      !hasContraseniaNuevaError ||
      !hasConfirmacionError
    ) {
      this.handleOnClick();
    }
  }

  toggleConfirm = () => {
    this.setState((prevState) => ({
      isConfirmOpen: !prevState.isConfirmOpen,
    }));
  };


  onEliminar = async () => {
    // e.preventDefault();
    // this.props.history.push({
    //   pathname: "/cotizacion",
    //   search: `?accion=eliminar`

    // });
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');
    //Agregado para mostrar los totales en la cabecera
    let datosJSON = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      idCarrito: idCarrito
    }
    await this.props.datosFacturacion(datosJSON);
    //Cargar Totales de la cabecera
    if (this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "") {
      let param = {
        pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
        totalItems: this.props.dataFacturacion.numItemsCarrito ? this.props.dataFacturacion.numItemsCarrito : "0",
        totalPrima: (this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal) ? this.props.dataFacturacion.carValoresTotales.primaTotal : "0.00",
        ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
      }
      await this.props.actualizarTotalesCabecera(param);
    }
    window.location.reload();

  }

  onDescargar1 = async () => {
    let datosJson = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      accion: "descargar",
      correo: this.props.datosCotizacion.correo,
      idCarrito: this.props.datosCarrito.productosCarrito.idCarrito
    }
    if (this.state.codigoProductoEspecial == 'comparador' || this.state.codigoProductoEspecial == 'pits' || this.state.codigoProductoEspecial == 'externo') {
      await this.props.descargarCotizacionAuto(datosJson)
    }
    //  else {
    //   await this.props.descargarCotizacion(datosJson)
    // }

    //let datosPago=this.props.datosCotizacion.datosDescarga;
    if (!this.props.datosCotizacion.generarCotizacionHasError) {
      //let newTab = window.open();
      //window.location.href = datosPago.urlPdf;
      //window.open(datosPago.urlPdf, "_blank")
    }
  }

  async onDescargar(event) {

    event.preventDefault()
    let datosJson = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      accion: "descargar",
      correo: this.props.datosCotizacion.correo,
      idCarrito: this.props.datosCarrito.productosCarrito.idCarrito
    }
    await this.props.descargarCotizacion(datosJson)
    //let datosPago=this.props.datosCotizacion.datosDescarga;
    if (!this.props.datosCotizacion.generarCotizacionHasError) {
      //let newTab = window.open();
      //window.location.href = datosPago.urlPdf;
      //window.open(datosPago.urlPdf, "_blank")
    }
  }

  async onEnviar(event) {

    console.log('this.props.datosCotizacion.correo', this.props.datosCotizacion)

    if (this.props.datosCotizacion.correo != "") {
      event.preventDefault()
      let datosJson = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        accion: "enviar",
        correo: this.state.email,
        idCarrito: this.props.datosCarrito.productosCarrito.idCarrito,
        url: this.props.datosCotizacion.datosDescarga.urlPdf
      }

      if (this.state.codigoProductoEspecial == 'comparador' || this.state.codigoProductoEspecial == 'pits') {
        await this.props.descargarCotizacionAuto(datosJson)
      } else {
        await this.props.descargarCotizacion(datosJson)
      }


      //let datosPago=this.props.datosCotizacion.datosDescarga;
      if (!this.props.datosCotizacion.generarCotizacionHasError) {
        //let newTab = window.open();
        //window.location.href = datosPago.urlPdf;
        //window.open(datosPago.urlPdf, "_blank")
      }
    }



  }

  onClickAtras = () => {

    this.props.history.push({
      pathname: "/listado-renovaciones"
    });

  }

  onClickModificar = () => {
    this.setState({
      isConfirmOpen: true,
      message: `¿Está seguro de que desea modificar el producto de la renovación actual?`,
      confirmAction: () =>
        this.modificarProducto()
    });
  }


  modificarProducto = async () => {
    try {
      let idCarrito = this.props.datosCarrito.productosCarrito.idCarrito
      const url = `${urlModificarProducto}&idCarrito=${idCarrito}`;
      const respuesta = await httpClient.get(url);
      const { transaccion, idRenovacion } = respuesta

      if (transaccion) {

        this.props.history.push({
          pathname: "/renovacion",
          search: `?id=${idRenovacion}`
        });


      }
      return console.log('verjson', respuesta)
      return respuesta;
    } catch (error) {
      console.error('Error en validarSiniestralidad:', error);
      return {
        transaccion: false,
        mensaje: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
      };
    }

  }

  esFullCobertura = () => {

    let esFull = true
    let renovacion = this.state.renovacionActual

    if (renovacion.productoExterno) {
      return false
    }
    let vehiculos = renovacion.reDatosProducto.reDatosVehiculo

    vehiculos.forEach(vehiculo => {

      if (vehiculo.rePlanSeleccionado != 'fullCobertura') {
        esFull = false
      }


    });

    let validacion = esFull

    return validacion

  }




  buscarPrimaMinima = async () => {

    const productos = this.props.datosCarrito.productosCarrito.carProductos;

    for (const vehiculo of productos) {

      console.log(vehiculo)


      const primaNeta = parseFloat(vehiculo.totales.prima_neta_anual_full_cobertura) || 0;
      const placa = vehiculo.datosProducto.placa;

      const renovacion = await this.obtenerRenovacion();

      if (renovacion.transaccion) {
        const renovacionActual = renovacion.arrayrenovaciones[0];

        console.log('renovacionActual2222', renovacion)

        if (renovacionActual) {

          this.setState({ renovacionActual: renovacionActual, filtros: renovacion.arrayFiltrosBack, filtrosPymes: renovacion.arrayFiltrosBackPymes })

          const vehiculoActual = renovacionActual.reDatosProducto.reDatosVehiculo.find(
            (v) => v.rePlaca === placa
          );

          const primaMinima = vehiculoActual ? parseFloat(vehiculoActual.rePrimaMinima) || 0 : 0;

          if (primaNeta < primaMinima) {
            return {
              error: true,
              primaMinima,
              placa,
              primaNeta,
            };
          }

        }



      }
    }

    return { error: false };
  };


  onClick = async (siniestralidad, prima) => {


    let carritoNuevo = await obtenerCarritoPorIdCarrito(this.props.datosCarrito.productosCarrito.idCarrito)



    const recalcular = carritoNuevo.data.carRecalcularValoresTasaRenovacion;



    let idCarrito = this.props.datosCarrito.productosCarrito.idCarrito
    let urlEnviar = "https://";
    if (ambienteAplicacion === "local") {
      urlEnviar = "http://";
    }
    urlEnviar = urlEnviar + window.location.host + "/resumen-cotizacion-renovacion?id=" + idCarrito + "&paso=datosfacturacion"
    const datosLead = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      idcarrito: idCarrito,
      url: urlEnviar,
      paso: "",
      accion: "Solicitar Informacion del Contratante Facturación."
    }

    if (this.state.codigoProductoEspecial == 'vehiculosKilometrosPaquete') {
      await apiGet(`${urlGuardarCodigoCuotas}${idCarrito}&cuotas=${this.state.cuotasSeleccionadas}&codigoBanco=${this.state.bancoSeleccionado}`)

    }

    if (siniestralidad) {

      if (recalcular) {

        this.setState({
          recalcular: true
        })

      } else {

        this.setState({
          recalcular: false
        })

        await this.props.actualizarLeadCotizacion(datosLead)
        this.props.history.push({
          pathname: "/confirmacion-cotizacion-renovacion",
          //search: `?accion=agregar`      
        });

      }

    }






  }

  onClickAgregar = (e) => {

    var search = '?accion=agregar'

    if (this.state.codigoProductoEspecial == 'comparador') {
      search = '?accion=agregar&codigoProductoEspecial=comparador'
    }
    if (this.state.codigoProductoEspecial == 'pits') {
      search = '?accion=agregar&codigoProductoEspecial=pits'
    }
    this.props.history.push({
      pathname: "/cotizacion",
      search: search

    });
  }
  redireccionar = () => {

    //console.log("URLOBTENIDA", window.location)
    const urlCompleta = window.location;
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');

    const objetoLeed = {
      path: urlCompleta.pathname,
      id: idCarrito
    }
    this.props.guardarDatosLeed(objetoLeed);


    localStorage.setItem("login", false);
    //this.props.limpiarDisclaimer();
    this.props.setDataUsuario(undefined);
    this.props.history.push({
      pathname: `/`
    });
  };
  async componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');
    const paso = queryParams.get('paso');
    let codigoProductoEspecial = queryParams.get("codigoProductoEspecial");
    let esNoPortal = queryParams.get("esNoPortal")
    let bloquearFullCobertura = queryParams.get("bloquearFullCobertura");


    if (esNoPortal) {
      this.setState({ esNoPortal: true });
    } else {
      this.setState({ esNoPortal: false });
    }

    if (bloquearFullCobertura) {
      this.setState({ bloquearFullCobertura: true });
    } else {
      this.setState({ bloquearFullCobertura: false });
    }
    if (codigoProductoEspecial != null) {

      console.log("codigoProductoEspecial", codigoProductoEspecial);
      this.setState({ codigoProductoEspecial: codigoProductoEspecial });
    } else {
      console.log("No codigoProductoEspecial");
    }

    console.log('this.state.codigoProductoEspecial', this.state.codigoProductoEspecial)

    this.props.listarColores(codigoProductoEspecial == 'comparador' || codigoProductoEspecial == 'pits' ? codigoProductoEspecial : null);
    await this.props.listarTerritorios();
    await this.props.listarAccesorios();
    await this.props.listarEciviles();
    await this.props.listarGeneros();
    await this.props.listarCarrito(idCarrito);
    await this.props.listarBancosCuotas();
    await this.onDescargar1();
    await this.props.recalcularCarrito(idCarrito)
    await this.onDescargar1();

    // if (this.props.datosCarrito.productosCarrito.actualizar) {
    if (this.props.datosCarrito.productosCarrito.carRecalcularValoresTasaRenovacion) {

      await this.props.recalcularCarrito(idCarrito)
      await this.onDescargar1();
      this.setState({
        recalculado: true
      })
    }




    //const planSeleccionado = this.props.datosCarrito.productosCarrito.carProductos[0].datosCalculoScoring.plan

    //const planes = this.props.datosCarrito.productosCarrito.carProductos[0].PlanesKmPaquete
    //console.log('datosCarrito: ', planes)
    //const maximoMeses = this.state.codigoProductoEspecial == 'vehiculosKilometrosPaquete' ? planes.find(plan => plan.codigo == planSeleccionado).vigenciaMeses.split(' ')[0] : 1
    //console.log('datosCarrito: ', planSeleccionado)
    // console.log('datosCarrito: ', planes)
    //console.log('datosCarrito: ', maximoMeses)
    /*   this.setState({
        maximoMeses: parseInt(maximoMeses)
      }) */
    //Agregado para mostrar los totales en la cabecera
    let datosJSON = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      idCarrito: idCarrito
    }
    await this.props.datosFacturacion(datosJSON);
    //Cargar Totales de la cabecera
    if (this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "") {
      let param = {
        pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera ? this.props.dataFacturacion.pathIconoTotalesCabecera : "",
        totalItems: this.props.dataFacturacion.numItemsCarrito ? this.props.dataFacturacion.numItemsCarrito : "0",
        totalPrima: (this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal) ? this.props.dataFacturacion.carValoresTotales.primaTotal : "0.00",
        ramoCotizador: this.props.dataFacturacion.carDescripcionRamo ? this.props.dataFacturacion.carDescripcionRamo : "",
      }
      await this.props.actualizarTotalesCabecera(param);
    }
    if (this.props.datosUsuarios && this.props.datosUsuarios.cliCodigoCore !== undefined && this.props.datosCarrito.productosCarrito.carDatosAsesor && this.props.datosCarrito.productosCarrito.carDatosAsesor.codigoCore != undefined) {
      if (this.props.datosUsuarios.cliCodigoCore !== this.props.datosCarrito.productosCarrito.carDatosAsesor.codigoCore) {
        //console.log("validacion login ")
        //this.redireccionar()
        console.log('Nedd Log', this.props.datosUsuarios)
        /*this.props.history.push({
          pathname: "/recuperar-cotizacion-error",
          search: `?mensaje=usuarioincorrecto`
        });*/

      }
      else {
        if (paso !== "resumen") {
          this.props.history.push({
            pathname: "/confirmacion-cotizacion-renovacion",
            //search: `?accion=agregar`      
          });
        }
      }
    }

    this.setState({
      cargandoinicial: false
    })


    let primaMinima = await this.buscarPrimaMinima()
  }

  textosCargando() {
    if (this.props.datosCarrito.isLoading)
      return "Obteniendo datos de resumen..."
    if (this.props.datosCotizacion.generarCotizacionIsLoading)
      //return "Generando PDF de Cotización..."
      return "Obteniendo datos de resumen..."
    if (this.props.datosCotizacion.enviarCotizacionIsLoading)
      return "Enviando Cotización al Cliente..."
    if (this.state.loadingSiniestralidad)
      return "Validando siniestralidad..."


  }



  render() {
    const { validate, placa, chasis, cargandoinicial } = this.state;
    let { datosCotizacion, datosCarrito, paso } = this.props;
    let productosCarrito = {}
    //console.log("datoscarrito ", datosCarrito)
    if (datosCarrito !== undefined) {
      //console.log("datoscarrito !undefined", datosCarrito)
      productosCarrito = datosCarrito.productosCarrito.carProductos;
      //console.log("datoscarrito productosCarrito !", datosCarrito)
      if (productosCarrito === undefined) {
        productosCarrito = {
          carProductos: [],
          valorTotal: {}
        }
        //this.redireccionar()
      }
      else {
        //console.log("datoscarrito productosCarrito !undefined", datosCarrito)
        productosCarrito = datosCarrito.productosCarrito;
      }

    }
    else {

    }

    let mostrarAgregarItems = datosCarrito.productosCarrito.AgregarItems !== undefined ? datosCarrito.productosCarrito.AgregarItems : true;

    console.log('ver21', mostrarAgregarItems)

    return (
      <LoadingScreen
        loading={

          datosCarrito.isLoading || this.props.datosCotizacion.generarCotizacionIsLoading || this.props.datosCotizacion.enviarCotizacionIsLoading || cargandoinicial || this.state.loadingSiniestralidad
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.textosCargando()}
      >

        {this.state.renovacionActual && validarBotonContinuar(transformarRenovacion(this.state.renovacionActual, this.state.filtros, this.state.filtrosPymes)) ?
          <Page
            title={this.state.codigoProductoEspecial == "comparador" || this.state.codigoProductoEspecial == "pits"
              ? this.state.codigoProductoEspecial == "pits" ? `Renovación PRACTIAUTO` : `Renovación AIG AUTO`
              : 'Renovación de vehículos'}

            breadcrumbs={[{
              name: this.state.codigoProductoEspecial == "comparador" || this.state.codigoProductoEspecial == "pits"
                ? this.state.codigoProductoEspecial == "pits" ? "PractiAuto" : "AIG Auto"
                : "Cotización de vehículos", active: true
            }]}
          >
            <Row>
              <Col lg={8} md={12} sm={12} xs={12}>
                <div className="container-step">
                  <div className="wrapper-step">
                    <div className="arrow-steps clearfix-step">
                      <div className="step"> {` 1. Renovación `} </div>
                      <div className="step current"> {` 2. Resumen `} </div>
                      <div className="step"> {` 3. Confirmación `} </div>
                      <div class="step"> {` 4. Forma de Pago `} </div>
                      <div class="step"> {` 5. Formulario de Vinculación `} </div>
                      <div class="step"> {` 6. Emisión `} </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box">
                {datosCarrito.productosCarrito !== undefined &&
                  productosCarrito.carProductos.map((carrito, index) => (


                    <ListadoProductosComparador renovacionActual={this.state.renovacionActual} length={productosCarrito.carProductos.length} esRenovacion={this.state.esRenovacion} esNoPortal={this.state.esNoPortal} codigoProductoEspecial={this.state.codigoProductoEspecial != null ? this.state.codigoProductoEspecial : null} ProductoEspecial={this.state.codigoProductoEspecial != null ? true : false} key={index} datosCotizacion={carrito} indice={index} origen={"resumen-cotizacion"} metodoEliminar={this.onEliminar}

                    />
                  ))}

                {/*   {this.state.codigoProductoEspecial == 'vehiculosKilometrosPaquete' && this.props.datosBancosCuotas.bancosCuotas && this.props.datosBancosCuotas.bancosCuotas.length > 0 &&  <Diferidos
                datosBancos={this.props.datosBancosCuotas.bancosCuotas}
                maximoMeses={this.state.maximoMeses}
                setCuotasSeleccionadasPrincipal={value => this.setState({ cuotasSeleccionadas: value })}
                setBancoSeleccionadoPrincipal={value => this.setState({ bancoSeleccionado: value })}
              />} */}




                {/* 
              <Button
                className={
                  "btn btn-primary"
                }
                onClick={this.onClickAtras}
                disabled={false}
                style={{ display: "block", margin: "0", marginBottom: 20 }}>
                <i
                  className='fa fa-chevron-circle-left'
                  aria-hidden='true'
                />{" "}
                {"ATRÁS"}
              </Button>
 */}
                <ButtonGroup style={{ display: "block", margin: "0", marginBottom: 20 }}>




                  <Button
                    className={
                      "btn btn-primary "
                    }
                    onClick={this.onClickAtras}

                  >
                    <i
                      className='fa fa-chevron-circle-left'
                      aria-hidden='true'
                    />{" "}
                    {'Regresar al listado de renovaciones'}
                  </Button>


                  {this.state.renovacionActual && this.esFullCobertura() &&
                    <Button
                      style={{ marginLeft: 20 }}
                      className={
                        "btn btn-detail-gray"
                      }
                      onClick={this.onClickModificar}

                    >
                      <i
                        className='fa fa-refresh'
                        aria-hidden='true'
                      />{" "}
                      {'Modificar producto'}
                    </Button>

                  }





                </ButtonGroup>

              </Col>

              <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box">
                <ValoresCotizacion
                  loadingSiniestralidad={this.state.loadingSiniestralidad}
                  setLoadingSiniestralidad={(loading) => this.setState({ loadingSiniestralidad: loading })}
                  email={this.state.email}
                  tieneErrorPrimaMinima={this.state.tieneErrorPrimaMinima}
                  mensajeErrorPrimaMinima={this.state.mensajeErrorPrimaMinima}
                  setEmail={(email) => { this.setState({ email: email }) }}
                  ProductoEspecial={this.state.codigoProductoEspecial != null && this.state.codigoProductoEspecial ? false : true}
                  formEditado={false}
                  paso={"resumen-cotizacion"}
                  metodo={(siniestralidad, prima, recalcular) => this.onClick(siniestralidad, prima, recalcular)}
                  metodoRecalcular={async () => {
                    const queryParams = new URLSearchParams(this.props.location.search);
                    const idCarrito = queryParams.get('id');
                    await this.props.recalcularCarrito(idCarrito)
                    await this.onDescargar1();
                    this.setState({
                      recalcular: false,
                      recalculado: true
                    })
                  }
                  }
                  recalcular={this.state.recalcular}
                  recalculado={this.state.recalculado}
                  metodoDescargar={this.onDescargar}
                  metodoEnviar={this.onEnviar}
                  valorTotal={productosCarrito.valorTotal}
                  codeProductoEspecial={this.state.codigoProductoEspecial}
                  bloquearFullCobertura={this.state.bloquearFullCoberturaCarrito}
                  mensajeFullCobertura={this.state.mensajeBloqueo}
                  esRenovacion={this.state.esRenovacion}
                  errorSiniestralidad={this.state.errorSiniestralidad}
                  mensajeErrorSiniestralidad={this.state.mensajeErrorSiniestralidad}
                  setErrorSinistralidad={(errorSiniestralidad, mensajeErrorSiniestralidad) => {

                    this.setState({
                      errorSiniestralidad: errorSiniestralidad,
                      mensajeErrorSiniestralidad: mensajeErrorSiniestralidad
                    })

                  }}

                />
              </Col>
            </Row>

            <ConfirmDialog
              isOpen={this.state.isConfirmOpen}
              toggle={this.toggleConfirm}
              message={this.state.message}
              onConfirm={() => {
                if (this.state.confirmAction) this.state.confirmAction();
              }}
            />
          </Page>
          :
          <ErrorPage mainText="No es posible continuar con esta renovación, ya que no se encuentra en el estado adecuado para proceder" secondaryText="Por favor, contacta al administrador si crees que esto es un error" />
        }

      </LoadingScreen>
    );
  }
}




const mapStateToProps = state => ({
  datosCotizacion: state.datosCotizacion,
  datosCarrito: state.dataProductoCarrito,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  dataFacturacion: state.dataFacturacion.datosFacturacion,
  datosBancosCuotas: state.dataBancosCuotas,
});

const mapDispatchToProps = dispatch => {
  return {
    listarCarrito: (idCarrito) => dispatch(FetchDataProductosCarrito(idCarrito)),
    recalcularCarrito: (idCarrito) => dispatch(FetchRecalcularCarrito(idCarrito)),
    descargarCotizacion: (datos) => dispatch(FetchDescargarCotizacionAutoRenovacion(datos)),
    descargarCotizacionAuto: (datos) => dispatch(FetchDescargarCotizacionAutoRenovacion(datos)),
    listarBancosCuotas: () => dispatch(FetchDataBancosCuotas()),
    setDataUsuario: data => dispatch(dataUsuario(data)),
    guardarDatosLeed: (data) => dispatch(setDataLeeds(data)),
    actualizarLeadCotizacion: (data) => dispatch(GuardarLeadFetch(data)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    actualizarTotalesCabecera: (param) => dispatch(FetchTotalesCabeceraCotizadores(param)),
    listarColores: (productoEspecial) => dispatch(listarColoresFetch(productoEspecial)),
    istarBancosCuotas: () => dispatch(FetchDataBancosCuotas()),
    listarTerritorios: () => dispatch(listarTerritoriosFetch()),
    listarAccesorios: () => dispatch(listarAccesoriosFetch()),
    listarEciviles: () => dispatch(listarECivilesFetch()),
    listarGeneros: () => dispatch(listarGenerosFetch()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Cotizacion3ResumenRenovacion)
);
